<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to Orit Josefi Wiseman, my wife, my best friend and the person who has to put up with my idiosyncrasies. She has the patience of an angel. As a child therapist, she is the model for Dana, the child therapist in the novel, who also loves children, the fragile flowers of the future and has the knack of earning and keeping their trust.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?87d3ddf6